import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {RouterQuery} from '@datorama/akita-ng-router-store';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {UserAuthorities} from '../../_shared/modules/agri-auth/constants/user-authorities.const';
import {User} from '../../_shared/modules/agri-auth/models/user.model';
import {SessionService} from '../../_shared/modules/agri-auth/state/session';
import {PageNames} from '../../constants/page-names.const';
import {DatePipe} from '@angular/common';
import {environment} from '@env/environment';
import {SoilAnalysisUploadQuery} from '../../state/soil-analysis-upload/soil-analysis-upload.query';
import {SoilAnalysisUploadService} from '../../state/soil-analysis-upload/soil-analysis-upload.service';
import {NavigationEventsService} from '../../services/navigation-events.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  @Input() user: User;
  @Output() openPowerBiModal: EventEmitter<void> = new EventEmitter<void>();
  pageNames = PageNames;
  pageName: PageNames;
  userRoles = UserAuthorities;
  soilAnalysisUploading$: Observable<boolean> = this.soilAnalysisUploadQuery.uploading$;
  authUrl: string = new URL(environment.authServerUrl).origin;

  @ViewChild('burger') burger;
  @ViewChild('sidenav') sidenav;
  showSidenav = false;

  constructor(
    private _routerQuery: RouterQuery,
    private _changeDetectorRef: ChangeDetectorRef,
    private _sessionService: SessionService,
    private _router: Router,
    private soilAnalysisUploadQuery: SoilAnalysisUploadQuery,
    private soilAnalysisUploadService: SoilAnalysisUploadService,
    private navigationEventsService: NavigationEventsService) {
  }

  ngOnInit() {
    this._routerQuery
      .select((router) => router.state.root.data.pageName)
      .pipe(takeUntil(this._destroyed$))
      .subscribe((pageName: PageNames) => {
        this.pageName = pageName;
        this._changeDetectorRef.markForCheck();
      });
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    if (!this.burger || !this.sidenav) {
      return;
    }
    if (!this.burger.nativeElement.contains(target) && !this.sidenav.nativeElement.contains(target)) {
      this.showSidenav = false;
    }
  }

  logout() {
    this._sessionService.logout().subscribe();
  }

  openNotification({state, queryParams}) {
    this._router.navigate([state], {queryParams});
  }

  onHomeClick(event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }
    this.navigationEventsService.requestHome();
  }

  onFilesAdded(files: File[]) {
    this.soilAnalysisUploadService.addFiles(files);
  }

  getUserInitials(): string {
    if (!this.user) {
      return '';
    }
    let firstInitial = '';
    let lastInitial = '';
    
    if (this.user.firstName && this.user.firstName.charAt(0)) {
      firstInitial = this.user.firstName.charAt(0).toUpperCase();
    }
    
    if (this.user.lastName && this.user.lastName.charAt(0)) {
      lastInitial = this.user.lastName.charAt(0).toUpperCase();
    }
    
    return firstInitial + lastInitial;
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
